export const MIN_EXPERIENCE = 0;
export const MAX_EXPERIENCE = 10;

export const EXPERIENCE_OPTIONS = [
	{ title: 'Any experience', id: 1, value: null, isDefault: true },
	{ title: '1+ years', id: 2, value: 1 },
	{ title: '3+ years', id: 3, value: 3 },
	{ title: '5+ years', id: 4, value: 5 },
	{ title: '8+ years', id: 5, value: 8 },
];
